const formatSynced = ({ value }) => (
    value === 1 ? 'Yes' : 'No'
);

export default formatSynced

